const POLICY_LINKS = [
  { label: 'Privacy Policy', href: 'https://m1ntaverse.com/policies/privacy-policy' },
  { label: 'Terms of Service', href: 'https://m1ntaverse.com/policies/terms-of-service' },
  { label: 'Return & Refund Policy', href: 'https://m1ntaverse.com/policies/refund-policy' },
  {
    label: 'G1 Services Terms & Conditions',
    href: 'https://m1ntaverse.com/pages/copy-of-m1nt-promotional-programs-official-rules',
  },
  { label: 'FAQ', href: 'https://m1ntaverse.com/pages/faq' },
]

const SOCIALS = [
  { label: 'Instagram', href: 'https://www.instagram.com/m1ntaverse/', icon: 'ri-instagram-line' },
  { label: 'Twitter / X', href: 'https://twitter.com/m1ntaverse', icon: 'ri-twitter-x-line' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@m1ntaverse', icon: 'ri-tiktok-line' },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/channel/UCYFUvGneEeiceECylH-hQgw',
    icon: 'ri-youtube-line',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100088890717257',
    icon: 'ri-facebook-line',
  },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/m1nt', icon: 'ri-linkedin-line' },
]

/** Footer shared with the M1NT website (logo, contact, policies, socials). */
export default function OwnerFooter() {
  return (
    <footer className="border-t border-m1-line-soft bg-m1-ground pb-[env(safe-area-inset-bottom,0px)]">
      <div className="mx-auto max-w-[1200px] px-[var(--gutter)] pb-8 pt-16">
        <div className="grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col items-start">
            <img
              src="/brand/m1nt-logo.png"
              alt="M1NT"
              draggable={false}
              className="block h-6 w-auto select-none"
            />
            <p className="mt-5 max-w-[22em] text-[15px] font-light leading-relaxed text-m1-muted">
              Reinventing the way you experience your collection.
            </p>
            <p className="mt-2 max-w-[22em] text-[15px] font-light leading-relaxed text-m1-muted">
              Premium Cases and Displays for Collectibles.
            </p>
          </div>

          <div className="flex flex-col">
            <h4 className="text-[14px] font-normal text-m1-muted">Talk with us</h4>
            <p className="mt-2.5 max-w-[22em] text-[15px] font-light leading-relaxed text-m1-muted">
              Can&apos;t find what you&apos;re looking for? Our team is ready to help.
            </p>
            <a
              href="mailto:contact@m1ntaverse.com"
              className="mt-3 inline-flex items-center gap-2 text-[15px] text-m1-violet transition-colors hover:text-m1-ink"
            >
              <i className="ri-mail-line text-base" aria-hidden="true" />
              contact@m1ntaverse.com
            </a>
          </div>

          <div className="flex flex-col">
            <h4 className="text-[14px] font-normal text-m1-muted">Our Policies</h4>
            <nav className="mt-2.5 flex flex-col text-[16px]">
              {POLICY_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-2 transition-colors hover:text-m1-violet"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="flex flex-col">
            <h4 className="text-[14px] font-normal text-m1-muted">Follow Us</h4>
            <div className="mt-3 flex flex-wrap gap-x-5 gap-y-3">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="text-m1-muted transition-colors hover:text-m1-violet"
                >
                  <i className={`${social.icon} text-xl`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-m1-line-soft pt-6">
          <p className="text-[14px] text-m1-muted">
            © {new Date().getFullYear()}, M1NT. All rights reserved. M1NT® is a registered trademark
            of M1NT, Inc.
          </p>
        </div>
      </div>
    </footer>
  )
}
